/**
 * 引擎全局状态 —— 单一真相。
 * 状态更新一律返回新对象（不可变），便于 P1 的撤销快照与 S1 的状态快照续做（§18.4）。
 */

import type { AssemblyGraph } from "../eom/assembly-graph.js";
import type { LabMode } from "../data/schemas.js";
import type { Scene } from "../scene/scene-manager.js";

export type EngineStatus = "idle" | "loaded" | "running" | "paused" | "disposed";

export interface EngineState {
  status: EngineStatus;
  mode: LabMode;
  packId: string | null;
  packTitle: string | null;
  graph: AssemblyGraph | null;
  scene: Scene | null;
}

export const INITIAL_STATE: EngineState = {
  status: "idle",
  mode: "learn",
  packId: null,
  packTitle: null,
  graph: null,
  scene: null,
};

export type StateListener = (state: EngineState, previous: EngineState) => void;

export class Store {
  private state: EngineState = INITIAL_STATE;
  private readonly listeners = new Set<StateListener>();

  getState(): EngineState {
    return this.state;
  }

  /** 合并式更新：返回新 state 对象，不就地改。 */
  update(patch: Partial<EngineState>): EngineState {
    const previous = this.state;
    this.state = { ...previous, ...patch };
    for (const listener of [...this.listeners]) {
      listener(this.state, previous);
    }
    return this.state;
  }

  reset(): EngineState {
    return this.update(INITIAL_STATE);
  }

  subscribe(listener: StateListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  clearListeners(): void {
    this.listeners.clear();
  }
}
